import styled from 'styled-components';

export const ForkStatus = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ForkingOxen = styled.div`
  height: 300px;
  background-image: url('/assets/images/forking_oxen.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 10px;
`;
